import * as Actions from "../../actions/app"
import { addOrUpdateObjectInArray } from "utils/add-or-update-object-in-array"
import { toggleIdInArray } from "utils/toggle-id-in-array"

const initialState = {
  saving_transfer_header: false,
  saved_transfer_header: false,
  saved_transfer_header_data: null,

  loading_transfers: false,
  transfers: [],
  total_transfers: 0,

  loading_transfer: false,
  transfer: null,

  loading_transfers_on_way: false,
  transfers_on_way: [],

  loading_finish_transfer_register: false,
  finished_transfer_register: false,

  voiding_transfer_ids: [],
  voided_transfer_ids: [],

  accepting_transfer_ids: [],
  accepted_transfer_ids: [],

  rejecting_transfer_ids: [],
  rejected_transfer_ids: [],

  enabling_transfer_ids: [],
}

const transfersReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.SAVE_TRANSFER_HEADER: {
      return {
        ...state,
        saving_transfer_header: action.payload.loading ?? false,
        saved_transfer_header: action.payload.saved ?? false,
        saved_transfer_header_data: action.payload.data ?? null,
        transfers: action.payload.data
          ? addOrUpdateObjectInArray(state.transfers, action.payload.data, 'traslado_id', true)
          : state.transfers,
      }
    }
    case Actions.GET_TRANSFERS: {
      return {
        ...state,
        loading_transfers: action.payload.loading ?? state.loading_transfers,
        transfers: action.payload.items ?? state.transfers,
        total_transfers: action.payload.total ?? state.total_transfers,
      }
    }
    case Actions.GET_TRANSFER_BY_ID: {
      return {
        ...state,
        loading_transfer: action.payload.loading ?? state.loading_transfer,
        transfer: action.payload.data ?? state.transfer,
      }
    }
    case Actions.GET_TRANSFERS_ON_WAY: {
      return {
        ...state,
        loading_transfers_on_way: action.payload.loading,
        transfers_on_way: action.payload.data ?? state.transfers_on_way,
      }
    }
    case Actions.FINISH_TRANSFER_REGISTER: {
      return {
        ...state,
        loading_finish_transfer_register: action.payload.loading,
        finished_transfer_register: action.payload.finished,
        transfers: action.payload.data
          ? addOrUpdateObjectInArray(state.transfers, action.payload.data, 'traslado_id')
          : state.transfers,
      }
    }
    case Actions.VOID_TRANSFER: {
      return {
        ...state,
        voiding_transfer_ids: toggleIdInArray(state.voiding_transfer_ids, action.payload.voiding_id),
        voided_transfer_ids: toggleIdInArray(state.voided_transfer_ids, action.payload.voided_id),
        transfers: action.payload.data
          ? addOrUpdateObjectInArray(state.transfers, action.payload.data, 'traslado_id')
          : state.transfers,
      }
    }
    case Actions.ACCEPT_TRANSFER: {
      return {
        ...state,
        accepting_transfer_ids: toggleIdInArray(state.accepting_transfer_ids, action.payload.accepting_id),
        accepted_transfer_ids: toggleIdInArray(state.accepted_transfer_ids, action.payload.accepted_id),
        transfers_on_way: state.transfers_on_way.filter(({ transfer }) => transfer.traslado_id !== action.payload.accepted_id)
      }
    }
    case Actions.REJECT_TRANSFER: {
      return {
        ...state,
        rejecting_transfer_ids: toggleIdInArray(state.rejecting_transfer_ids, action.payload.rejecting_id),
        rejected_transfer_ids: toggleIdInArray(state.rejected_transfer_ids, action.payload.rejected_id),
        transfers_on_way: state.transfers_on_way.filter(({ transfer }) => transfer.traslado_id !== action.payload.rejected_id)
      }
    }
    case Actions.ENABLE_TRANSFER_EDITING: {
      return {
        ...state,
        enabling_transfer_ids: toggleIdInArray(state.enabling_transfer_ids, action.payload.enabling_id),
        transfers: action.payload.data
          ? addOrUpdateObjectInArray(state.transfers, action.payload.data, 'traslado_id')
          : state.transfers,
      }
    }
    default: {
      return state
    }
  }
}
export default transfersReducer
